export const handleRouteChange = (visitorId, type, signupReferrer, username) => (location) => {
    try {
        const referrer = localStorage.getItem("referrer");
        if (signupReferrer || referrer) {
            const queryParams = new URLSearchParams({
                path: location.pathname,
                type: `${type}-${username || visitorId}`,
                community: signupReferrer || referrer
            }).toString();
            const url = `https://ads.scored.co/api/tag?${queryParams}`;

            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => console.log(data))
                .catch((error) => console.error('Error fetching tag API:', error));
        }
    } catch (error) {
        console.error('Error handling route change:', error);
    }
};

export const handleAdImp = (visitorId, signupReferrer, username) => (location) => {
    try {
        const referrer = localStorage.getItem("referrer");

        if (signupReferrer || referrer) {
            const queryParams = new URLSearchParams({
                path: location.pathname,
                type: `imp-${username || visitorId}`,
                community: signupReferrer || referrer
            }).toString();
            const url = `https://ads.scored.co/api/tag?${queryParams}`;

            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => console.log(data))
                .catch((error) => console.error('Error fetching tag API:', error));
        }
    } catch (error) {
        console.error('Error handling route change:', error);
    }
};
